import React, { useState, useContext, useEffect, useRef } from 'react';
import './footer.css';
import { Context } from '../../store';
import appstore_img from '../../images/appstore.svg';
import playstore_img from '../../images/playstore.svg';
import volume_img from '../../images/volume.svg';
import donate_button from '../../images/donate.svg';
import boosty_img from '../../images/boosty.svg';

const toggleDonateForm = () => {
  const donateForm = document.getElementById('donate-form');
  const donateTab = document.getElementById('project-support');
  const tabList = document.getElementsByClassName('tab');

  if (donateTab.style.display === 'flex') {
    Array.from(tabList).forEach((el) => { el.style.display = 'flex' })
    donateForm.style.visibility = 'hidden';
    donateTab.style.display = 'none';
  } else {
    Array.from(tabList).forEach((el) => { el.style.display = 'none' })
    donateForm.style.visibility = 'visible';
    donateTab.style.display = 'flex';
  }
}

const Footer = () => {
  const [state, dispatch] = useContext(Context);
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const volumeRef = useRef(null);
  
  // Load volume from localStorage on mount
  useEffect(() => {
    const savedVolume = localStorage.getItem('myata_volume');
    if (savedVolume !== null) {
      dispatch({ volume: parseFloat(savedVolume) });
    }
  }, [dispatch]);

  // Save volume to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('myata_volume', state.volume);
  }, [state.volume]);

  // Close slider when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (volumeRef.current && !volumeRef.current.contains(event.target)) {
        setShowVolumeSlider(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleVolumeSlider = (e) => {
    e.stopPropagation();
    setShowVolumeSlider(!showVolumeSlider);
  };

  // Custom slider drag handler
  const handleSliderDrag = (e) => {
    e.preventDefault();
    const container = e.currentTarget; // Now directly on the track
    const rect = container.getBoundingClientRect();
    
    const updateVolume = (clientY) => {
      const y = clientY - rect.top;
      const height = rect.height;
      // Invert because top = max volume
      const newVolume = Math.max(0, Math.min(1, 1 - (y / height)));
      dispatch({ volume: newVolume });
    };

    updateVolume(e.clientY);

    const handleMouseMove = (moveEvent) => {
      updateVolume(moveEvent.clientY);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Touch support
  const handleSliderTouch = (e) => {
    e.preventDefault();
    const container = e.currentTarget; // Now directly on the track
    const rect = container.getBoundingClientRect();
    
    const updateVolume = (clientY) => {
      const y = clientY - rect.top;
      const height = rect.height;
      const newVolume = Math.max(0, Math.min(1, 1 - (y / height)));
      dispatch({ volume: newVolume });
    };

    const touch = e.touches[0];
    updateVolume(touch.clientY);

    const handleTouchMove = (moveEvent) => {
      const touch = moveEvent.touches[0];
      updateVolume(touch.clientY);
    };

    const handleTouchEnd = () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };

    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
  };

  return (
    <div className='footer'>
      <div className="container">
        <div className='footer_links'>
          <a href='https://t.me/radiomyata/4498' className='store_link' target='_blank' rel="noreferrer">
            <img src={appstore_img} alt='App Store' />
          </a>
          <a href='https://play.google.com/store/apps/details?id=dlinemedia.radioplayer.myata' className='store_link' target='_blank' rel="noreferrer">
            <img src={playstore_img} alt='Google Play' />
          </a>
          
          <div className='volume_control' ref={volumeRef}>
            <img 
              src={volume_img} 
              alt='Громкость' 
              onClick={toggleVolumeSlider}
              className='volume_icon'
            />
            {showVolumeSlider && (
              <div className='volume_slider_container'>
                <div 
                  className='custom_slider_track'
                  onMouseDown={handleSliderDrag}
                  onTouchStart={handleSliderTouch}
                >
                  <div 
                    className='custom_slider_thumb'
                    style={{ bottom: `calc(${state.volume * 100}% - 14px)` }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='donate_button' onClick={toggleDonateForm}>
          <img src={donate_button} alt='Донат' />
        </div>

        <div className='volume_link_container'>
          <a href='https://boosty.to/myata' className='boosty_link' target='_blank' rel="noreferrer">
            <img src={boosty_img} alt='Boosty' />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer;


